<template>
    <!-- INICIO NewEventSelector -->
    <BaseModal v-if="!globals.isMobile" modalId="newEventForm" :title="'Agregar Evento'" :isVisible="true" :showHideButton="false"
        :enableClickOutside="false" @close="closeDialog">
        <div>
            <div class="modal-body">

                <!-- Sección de coordenadas -->
                <div class="coordinates-section">
                    <div class="row justify-content-center">
                        <div class="col-4">
                            <h4>Seleccione icono del tipo de evento</h4>
                        </div>
                        <div class="col-2">
                        <h4>ó</h4>
                        </div>
                        <div class="col-4">
                            <button class="btn btn-sm btn-coordinates" @click="copyCoordinates"><i class="bi bi-clipboard me-2"></i>Copiar Coordenadas</button>
                        </div>
                    
                </div>
                </div>

                  <!-- Línea separadora -->
                <hr class="separator">

                <button v-for="evt in eventTypes" :key="evt.event_type_id" class="btn btn-sm btn-evento"
                    @click="selectNewEvent(evt.event_type_id)">
                    <span class="icono-wrapper">
                        <img class="icono" :src="'/images/event_type_' + evt.event_type_id + '.png'"
                            :alt="evt.event_type || 'Event Icon'" :title="evt.event_type || 'Evento'">
                    </span>
                </button>

              

                
            </div>
        </div>
    </BaseModal>
    <!-- Versión móvil -->
    <div v-else class="mobile-selector-overlay">
        <div class="mobile-selector-content">
            <h4 class="mb-3 text-center">Selecciona el tipo de evento</h4>
            <div class="mobile-event-types d-flex flex-wrap justify-content-center gap-3">
                <button
                    v-for="evt in eventTypes"
                    :key="evt.event_type_id"
                    class="btn-mobile-evento"
                    @click="selectNewEvent(evt.event_type_id)"
                >
                    <span class="icono-wrapper">
                        <img
                            v-if="evt.event_type_id > 100"
                            class="fondo-icono-mobile"
                            :src="'/images/' + evt.event_bg + '.png'"
                            alt="Fondo especial"
                        />
                        <img
                            class="icono"
                            :src="'/images/event_type_' + evt.event_type_id + '.png'"
                            :alt="evt.event_type || 'Event Icon'"
                            :title="evt.event_type || 'Evento'"
                        >
                    </span>
                </button>
            </div>
            <button class="btn-mobile-cerrar mt-4" @click="closeDialog">Cancelar</button>
        </div>
    </div>
    <!-- FIN NewEventSelector -->
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useServicesStore } from '@/stores/services';
import { useGlobalStore } from '@/stores/global';
import { storeToRefs } from 'pinia';
import type { NewEventData } from '@/types';
import BaseModal from './base/BaseModal.vue'


const props = defineProps<{
    newEventData: NewEventData
}>()

const datos = useServicesStore();
const globals = useGlobalStore();
const { eventTypes } = storeToRefs(datos);

const emit = defineEmits<{
    (event: 'close'): void,
    (event: 'buttonSelected', datos: NewEventData): void
}>()

function selectNewEvent(eventTypeId: number) {
    let datos: NewEventData = {
        event_type_id: eventTypeId,
        lat: props.newEventData.lat,
        lon: props.newEventData.lon
    }
    emit('buttonSelected', datos)
}

function copyCoordinates() {
    const lat = props.newEventData.lat
    const lon = props.newEventData.lon
    const coordinates = `${lat}, ${lon}`

    // Guardar en el store global
    globals.copyCoordinatesToClipboard(lat, lon, 'NewEventSelector')

    // Copiar al clipboard del sistema
    navigator.clipboard.writeText(coordinates).then(() => {
        console.log('Coordenadas copiadas al sistema y guardadas globalmente:', coordinates)
        // Cerrar la ventana después de copiar exitosamente
        closeDialog()
    }).catch(err => {
        console.error('Error al copiar coordenadas al sistema:', err)
        // Fallback para navegadores que no soportan clipboard API
        const textArea = document.createElement('textarea')
        textArea.value = coordinates
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        console.log('Coordenadas copiadas (fallback) y guardadas globalmente:', coordinates)
        // Cerrar la ventana después de copiar con fallback
        closeDialog()
    })
}

function closeDialog() {
    console.log('Cerrando NewEventSelector')
    emit('close')
}

// Función para manejar tecla Escape
function handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
        console.log('Escape presionado')
        closeDialog()
    }
}

onMounted(() => {
    console.log('NewEventSelector montado')
    document.addEventListener('keydown', handleEscKey)
})

onUnmounted(() => {
    console.log('NewEventSelector desmontado')
    document.removeEventListener('keydown', handleEscKey)
})
</script>

<style lang="css" scoped>
.modal-body {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding-top: 10px;
    margin-right: -15px;
    justify-content: center;
}

.btn-evento {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 5px;
    background-color: #f0f0f0;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-evento:hover {
    background-color: #e0e0e0;
}

.icono {
    width: 32px;
    height: 32px;
}

.separator {
    width: 100%;
    margin: 5px 0;
    border: 0;
    height: 1px;
    background-color: #dee2e6;
}

.coordinates-section {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
}

.btn-coordinates {
    background-color: #dee2e6;
    color: rgb(0, 0, 0);
    border: 1px solid #dee2e6;
    padding: 8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.btn-coordinates:hover {
    background-color: #686868;
    border-color: #686868;
    color: white;
    border: 2px solid white;
}

.btn-coordinates:active {
    transform: scale(0.98);
}

h4 {
    text-align: center;
    font-size: medium;
}

.col-4, .col-2 {
    display: flex;
    justify-content: center;
    align-items: center;
}
/* Estilos para superponer el fondo debajo del icono */
.icono-wrapper {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;
}
.fondo-icono {
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    z-index: 1;
}
.fondo-icono-mobile {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    z-index: 1;

}
.icono {
    position: relative;
    z-index: 2;
}
.mobile-selector-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.35);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-selector-content {
    background: #fff;
    border-radius: 16px;
    padding: 24px 12px;
    width: 95vw;
    max-width: 400px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mobile-event-types {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
}

.btn-mobile-evento {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #fff; /* Fondo blanco */
    color: #1976d2;
    border: 3px solid #1976d2; /* Borde azul */
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    transition: background 0.2s, border-color 0.2s;
    cursor: pointer;
    padding: 0;
}

.btn-mobile-evento:active {
    border-color: #1565c0;
    background: #f0f6fa;
}

.btn-mobile-evento .icono-wrapper {
    width: 40px;
    height: 40px;
}

.btn-mobile-evento .icono,
.btn-mobile-evento .fondo-icono {
    width: 40px;
    height: 40px;
}

.btn-mobile-cerrar {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    background: #e53935;
    color: #fff;
    border: none;
    font-size: 1.1rem;
    font-weight: bold;
    margin-top: 16px;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-mobile-cerrar:active {
    background: #b71c1c;
}
</style>